<div>
  <h2>Вы действительно хотите выйти?</h2>

  <div class="confirm-actions">
    <button mat-raised-button color="warn" (click)="close(true)">Выйти</button>
    <button mat-button (click)="close(false)">Отмена</button>
  </div>
</div>
